import { BetType } from "./bet-type.model";
import { Category } from "./category.model";
import { Tournament } from "./tournament.model";

export interface Match extends Category, Tournament {
  Id: number;
  Hometeam: string;
  Awayteam: string;
  Date: string;
  BetTypes: BetType[];
  BetTypeCount: number;
  Live?: boolean;
  Active: boolean;
  Score: string;
  RemainingTime: string | null;
  BetStatus: boolean;
  MatchIdentifier: string;
  MatchNumber: number;
  MatchStatus: MatchStatus;
  MatchTime: number;
  Outright: boolean;
  MinCombination: number;
  MatchTimeExtended: string | null;
  SetScore: string;
  GameScore: string | null;
  Service: number;
  LiveOdds: boolean;
  PeriodLength: string | null;
  AwayteamRedCards: number;
  HometeamRedCards: number;
  AwayteamYellowCards: number;
  HometeamYellowCards: number;
  BrMatchID: number;
  IsH2H: boolean;
  IsEsport: boolean;
  HometeamBrUniqueID: number;
  AwayteamBrUniqueID: number;
  AwayteamMultiLang: Record<string, string> | null;
  HometeamMultiLang: Record<string, string> | null;
  Version: number;
}

export interface GoalUpdate {
  MatchID?: number;
  Id?: number;
  NewScore?: Match['Score'] | null;
  Score?: Match['Score'] | null;
}

export enum MatchStatus {
  ERROR = 0,
  NOT_STARTED = 1,
  PERIOD_1 = 2,
  PERIOD_2 = 3,
  PERIOD_3 = 4,
  PAUSED = 5,
  OVERTIME = 6,
  PENALTY = 7,
  INTERRUPTED = 8,
  ENDED = 9,
  SET1 = 10,
  SET2 = 11,
  SET3 = 12,
  SET4 = 13,
  SET5 = 14,
  WALKOVER = 15,
  RETIRED = 16,
  DELAYED = 17,
  PERIOD_4 = 18,
  PERIOD_5 = 19,
  AWAITING_OT = 20,
  ABANDONED = 21,
  CANCELED = 22,
  POSTPONED = 23,
  PAUSE_1 = 24,
  PAUSE_2 = 25,
  PAUSE_3 = 26,
  PAUSE_4 = 27,
  PAUSE_OT = 48,
  AWAITING_PENALTY = 49
}
